import { BaseEnum } from "../BaseEnum";

export class EsgStatus extends BaseEnum {
  static NON_COMPLIANT = 1;
  static COMPLIANT = 2;

  static Codes = [this.NON_COMPLIANT, this.COMPLIANT];
  static _labelKeys = ["NON_COMPLIANT", "COMPLIANT"];
}
